import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import RecentlyReturnedTitle from '../RecentlyReturnedTitle';
import BorrowingEmptyContentPanel from '../../shared/BorrowingEmptyContentPanel';
import { BorrowingHistoryIcon } from '@bibliocommons/base-icons';

export default function RecentlyReturnedEmptyContentPanel({ fetching }) {
  return (
    <div className="cp-recentlyreturned">
      <div className="title-row">
        <RecentlyReturnedTitle />
        <BorrowingEmptyContentPanel
          className="cp-recentlyreturned-empty-content-panel"
          showStaffPicksLink={false}
          fetching={fetching}
          helpPage="040settings/005privacy-settings"
          icon={<BorrowingHistoryIcon />}
          title={<FormattedMessage id="empty_recentlyreturned_is_enabled_title" />}
          subtitle={<FormattedMessage id="empty_recentlyreturned_is_enabled_text" />} />
      </div>
    </div>
  );
}

RecentlyReturnedEmptyContentPanel.propTypes = {
  fetching: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturnedEmptyContentPanel/RecentlyReturnedEmptyContentPanel.jsx